export default function Logo(){
    return (
        <h1>🌴🌴 FAR AWAY  💼💼</h1>
    );
}
